import PropTypes from 'prop-types'
import ProductPerPageFilterField from 'domains/product/organisms/paging-filter-field/product-per-page-filter-field'
import ProductSortFilterField from 'domains/product/organisms/paging-filter-field/product-sort-filter-field'
import { ListGroup, ListGroupItem } from 'reactstrap'

const propTypes = {
  perPage               : PropTypes.string,
  sortBy                : PropTypes.string,
  sortDir               : PropTypes.string,
  handlePerPageOnChange : PropTypes.func,
  handleSortOnClick     : PropTypes.func
}

const defaultProps = {
  perPage               : '10',
  sortBy                : '',
  sortDir               : '',
  handlePerPageOnChange : () => { },
  handleSortOnClick     : () => {}
}

const ProductPagingFilterField = ({
  perPage,
  sortBy,
  sortDir,
  handlePerPageOnChange,
  handleSortOnClick
}) => (
  <>
    <ListGroup className='pb-2'>
      <ListGroupItem>
        <ProductPerPageFilterField
          perPage={ perPage }
          handlePerPageOnChange={ handlePerPageOnChange }
        />
      </ListGroupItem>

      <ListGroupItem>
        <ProductSortFilterField
          sortBy={ sortBy }
          sortDir={ sortDir }
          handleSortOnClick={ handleSortOnClick }
        />
      </ListGroupItem>
    </ListGroup>
  </>
)

ProductPagingFilterField.propTypes    = propTypes
ProductPagingFilterField.defaultProps = defaultProps

export default ProductPagingFilterField
